import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AuthService } from 'src/app/core/auth/auth.service';
import { OrganizacionService } from '@core/yalo';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private _isRefreshing = false;
  private _accessToken = new BehaviorSubject<string>(null);
  /**
   * Constructor
   */
  constructor(
    private _authService: AuthService,
    private _organizacionService: OrganizacionService
  ) { }

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request object
    let newReq = req.clone();

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.
    if (this._authService.accessToken && !newReq.url.includes('amazonaws.com')) {
      newReq = req.clone({
        headers: req.headers.set(
          'Authorization',
          'Bearer ' + this._authService.accessToken
        ),
      });
    }

    // Response
    return next.handle(newReq).pipe(
      catchError((error) => {
        // Catch "401 Unauthorized" responses
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this._handle401Error(req, next);
        }

        return throwError(error);
      })
    );
  }
  private _handle401Error(req: HttpRequest<any>, next: HttpHandler) {
    if (!this._isRefreshing) {
      this._isRefreshing = true;
      this._accessToken.next(null);

      const CodOrganizacion =
        this._organizacionService.obtenerOrganizacionActiva();

      return this._authService.refrescarToken(CodOrganizacion, CodOrganizacion, null, 1).pipe(
        catchError((error) => {
          this._logoutUser();

          return throwError(error);
        }),
        switchMap((jwt: any) => {
          this._accessToken.next(jwt);
          return next.handle(this._addToken(req, jwt));
        })
      );
    } else {
      return this._accessToken.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => next.handle(this._addToken(req, jwt)))
      );
    }
  }
  private _logoutUser(): any {
    // Sign out
    this._authService.signOut();

    // Reload the app
    //location.reload();
  }

  private _addToken(req: HttpRequest<any>, jwt: string): HttpRequest<any> {
    return req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + jwt),
    });
  }
}
